(function () {
  'use strict';

  var EXCLUDE_KEYWORDS = [
    'stampe', 'giapponesi', 'contemporanei', 'mostre', 'acquisizioni',
    'tutte', 'vasi', 'sculture', 'frontpage', 'natale', 'primavera',
    'astrattismo', 'spazialismo', 'optical', 'informale', 'catalogo',
    'novita', 'selezione', 'evidenza'
  ];

  function getQuery() {
    var params = new URLSearchParams(window.location.search);
    return (params.get('q') || '').trim();
  }

  function getArtistHandles() {
    var el = document.getElementById('artist-collection-handles');
    if (!el) return [];
    try {
      return JSON.parse(el.textContent) || [];
    } catch (e) {
      return [];
    }
  }

  function isArtistCollection(collection, artistHandles) {
    if (artistHandles.length > 0) {
      return artistHandles.indexOf(collection.handle) !== -1;
    }
    var h = collection.handle.toLowerCase();
    return !EXCLUDE_KEYWORDS.some(function (k) { return h.indexOf(k) !== -1; });
  }

  function stripHtml(html) {
    var div = document.createElement('div');
    div.innerHTML = html;
    return div.textContent || div.innerText || '';
  }

  function truncate(text, length) {
    text = text.trim();
    if (text.length <= length) return text;
    return text.slice(0, length).replace(/\s+\S*$/, '') + '\u2026';
  }

  function buildCard(collection) {
    var imageHtml;
    if (collection.featured_image && collection.featured_image.url) {
      imageHtml =
        '<img' +
        ' src="' + collection.featured_image.url + '"' +
        ' alt="' + escapeHtml(collection.featured_image.alt || collection.title) + '"' +
        ' class="artist-card__image"' +
        ' width="300" height="300"' +
        ' loading="lazy"' +
        '>';
    } else {
      imageHtml =
        '<div class="artist-card__placeholder">' +
          '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">' +
            '<path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/>' +
            '<circle cx="12" cy="7" r="4"/>' +
          '</svg>' +
        '</div>';
    }

    var excerptHtml = '';
    if (collection.body) {
      var excerpt = truncate(stripHtml(collection.body), 220);
      if (excerpt) {
        excerptHtml = '<p class="artist-card__excerpt">' + escapeHtml(excerpt) + '</p>';
      }
    }

    return (
      '<a href="' + collection.url + '" class="artist-card">' +
        '<div class="artist-card__image-wrapper">' + imageHtml + '</div>' +
        '<div class="artist-card__info">' +
          '<h3 class="artist-card__name">' + escapeHtml(collection.title) + '</h3>' +
          excerptHtml +
        '</div>' +
        '<span class="artist-card__cta">Vedi tutte le opere \u2192</span>' +
      '</a>'
    );
  }

  function escapeHtml(text) {
    var div = document.createElement('div');
    div.textContent = text;
    return div.innerHTML;
  }

  function render(artists) {
    var wrapper = document.getElementById('search-artist-section-js');
    var grid = document.getElementById('search-artist-grid-js');
    if (!wrapper || !grid) return;

    if (artists.length === 0) return;

    grid.innerHTML = artists.map(buildCard).join('');
    wrapper.removeAttribute('hidden');
  }

  function init() {
    var query = getQuery();
    if (query.length < 2) return;

    var artistHandles = getArtistHandles();

    var controller = new AbortController();
    var timeout = setTimeout(function () { controller.abort(); }, 5000);

    fetch(
      '/search/suggest.json?q=' + encodeURIComponent(query) +
      '&resources[type]=collection&resources[limit]=5',
      { signal: controller.signal }
    )
      .then(function (res) {
        clearTimeout(timeout);
        if (!res.ok) throw new Error('fetch error');
        return res.json();
      })
      .then(function (data) {
        var collections = (data.resources && data.resources.results && data.resources.results.collections) || [];
        var artists = collections.filter(function (c) {
          return isArtistCollection(c, artistHandles);
        });
        render(artists);
      })
      .catch(function (err) {
        if (err.name !== 'AbortError') console.warn('Search artist cards:', err);
      });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();